export class User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: string;

  api_token_expires: Date;
  created_at: Date;
  updated_at: Date;

  isLoggedIn: boolean;

  constructor(data: any) {
    console.log(data);

    // Set normal fields
    this.id = data.id;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.email = data.email;
    this.role = data.role;

    // Parse date fields
    this.api_token_expires = new Date(Date.parse(data.api_token_expires));
    this.created_at = new Date(Date.parse(data.created_at));
    this.updated_at = new Date(Date.parse(data.updated_at));

    // Parse other fields
    this.isLoggedIn = this.api_token_expires.getTime() > Date.now();
  }
}
